import React, { FC } from 'react';

import { Box, Heading } from '@rover/kibble/core';
import { FooterSection } from '@rover/rsdk/src/apiClient/latest';
import useFooterShim from '@rover/shared/js/hooks/useFooterShim';

import { renderFooterItemsAsChunk } from './utils';

export type contentProps = {
  aboutRover: FooterSection;
};

const AboutRoverLinks: FC = () => {
  const { footer } = useFooterShim();
  const { aboutRover } = footer || {};

  if (!aboutRover?.visible) return null;
  return (
    <Box maxWidth={['none', '45%']}>
      <Heading size="300" my="6x" as="div">
        {aboutRover.name}
      </Heading>
      <Box display="flex">{renderFooterItemsAsChunk(aboutRover.items, 6)}</Box>
    </Box>
  );
};

export default AboutRoverLinks;
